import debounce from 'lodash.debounce';
import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const buildMarkerEntities = (
  layerKey,
  { markerId, status, cameraId, irpVersion, portal } = {},
) => ({
  layer_name: layerKey || 'unknown',
  ...(markerId != null && { marker_id: markerId }),
  ...(status != null && { status }),
  ...(cameraId != null && { camera_id: cameraId }),
  ...(irpVersion != null && { irp_version: irpVersion }),
  ...(portal != null && { portal }),
});

export const emitMarkerHover = (layerKey, info) => {
  gspx.trackEvent({
    name: 'spatial_marker_hover',
    type: GPX_EVENT_TYPES.HOVER,
    feature: GPX_FEATURES.GIS,
    capability: GPX_CAPABILITIES.GIS,
    route: GPX_ROUTES.MAP,
    entities: buildMarkerEntities(layerKey, info),
  });
};

const emitMarkerClick = (layerKey, info) => {
  gspx.trackEvent({
    name: 'spatial_marker_click',
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.GIS,
    capability: GPX_CAPABILITIES.GIS,
    route: GPX_ROUTES.MAP,
    entities: buildMarkerEntities(layerKey, info),
  });
};

export const trackMarkerHover = debounce(emitMarkerHover, 500);

export const trackMarkerClick = debounce(emitMarkerClick, 500, {
  leading: true,
  trailing: false,
});

export const trackDeckGLHoverOnSpatialObject = ({
  externalId,
  source,
  irpVersion,
}) => {
  trackMarkerHover(source, { markerId: externalId, irpVersion });
};

export const trackDeckGLClickOnSpatialObject = ({
  externalId,
  source,
  irpVersion,
}) => {
  trackMarkerClick(source, { markerId: externalId, irpVersion });
};

export const trackActiveGeofenceHover = debounce(irpVersion => {
  gspx.trackEvent({
    name: 'map_active_geofence_hover',
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: 'Data Map',
      legacy_name: 'Hover an active geofence',
      Category: 'ESRI Map',
      'Launched date': new Date(),
      irpVersion,
    },
  });
}, 500);
